<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("Shift") }} {{ $tc("Logs", 2) }} {{ $t("Transactions") }}
      </div>
      <div>
        <div class="d-flex">
          <button class="btn-blue-sm h-10 w-auto" @click="handleFetch()">
            {{ $t("fetch") }}
          </button>
          <div
            v-if="combinedData.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
            <a
              target="_blank"
              @click="getShiftLogsTransaction(shift_id, (isExcel = 'Y'))"
              title="Download as Excel"
              download
              style="cursor: pointer"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div style="overflow-x: scroll; width: auto !important">
        <table class="swc-report-table" border="1" id="myTable">
          <thead class="bg-lightgrey font-weight-bold">
            <tr>
              <th rowspan="1" class="text-left border-bottom-0">
                {{ $t("Customer Name") }}
              </th>
              <th class="border-bottom-0">
                {{ $tc("Customer Phone") }}
              </th>
              <th class="text-center">
                {{ $tc("Transaction Date & time") }}
              </th>

              <th class="border-bottom-0">{{ $t("Booking code") }}</th>

              <th class="border-bottom-0">{{ $t("Screen") }}</th>

              <th class="border-bottom-0">{{ $t("Film/Items") }}</th>
              <th class="border-bottom-0">{{ $t("Show Date & Time") }}</th>
              <th class="border-bottom-0">{{ $t("Seats") }}</th>
              <th class="border-bottom-0">
                {{ $t("Payment Mode") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Quantity") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Offer/Voucher") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Amount") }}
              </th>

              <th class="border-bottom-0">
                {{ $t("Refunded Amount") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Total Amount") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Addons Amount") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="combinedData.length">
              <tr v-for="(transaction, transactionIndex) in combinedData">
                <td class="text-left">
                  {{
                    transaction.customer_name || transaction.guest_name || "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    transaction.cust_mobile || transaction.guest_mobile || "-"
                  }}
                </td>

                <td class="text-left">
                  {{
                    transaction.t_booking_date_time || transaction.ft_date_time
                  }}
                </td>
                <td class="text-left">
                  {{
                    transaction.movie_name
                      ? transaction.show_booking_code
                      : `${transaction.order_code}${
                          transaction.show_booking_code
                            ? `(${transaction.show_booking_code})`
                            : ""
                        } `
                  }}
                </td>
                <td class="text-left">{{ transaction.screen_name || "-" }}</td>
                <td class="text-left">
                  {{ transaction.movie_name || transaction.item_names }}
                </td>
                <td class="text-left">
                  {{
                    transaction.show_date_time ||
                    transaction.sb_booking_date_time ||
                    "-"
                  }}
                </td>
                <td class="text-left">{{ transaction.seat_names || "-" }}</td>
                <td class="text-left">{{ transaction.payment_mode_name }}</td>
                <td class="text-right">{{ transaction.quantity || 0 }}</td>

                <td class="text-right">
                  {{
                    parseFloat(transaction.offer_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(transaction.amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(transaction.total_refunded_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(transaction.total_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(transaction.addons_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
              </tr>
            </template>

            <template v-if="!combinedData.length">
              <td colspan="14">No Records</td>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsService from "@/services/NewReportService";

export default {
  name: "editShiftClose",
  data() {
    return {
      transactionData: [],
      fnbTransactionData: [],
      combinedData: [],
      shift_id: null,
    };
  },
  computed: {
    // ...mapGetters(["getUserShiftPaymentTypes"])
    getShiftClosePaymentTypes() {
      return this.paymentList;
    },
    shiftClosePaymentTotal() {
      return this.paymentList.reduce(
        (acc, { amount }) => acc + parseFloat(amount),
        0
      );
    },
  },
  beforeMount() {
    const { shift_id } = this.$route.query;

    if (shift_id) {
      // this.getPaymentTypes();
      this.shift_id = shift_id;
      this.getShiftLogsTransaction(shift_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    handleFetch: function () {
      this.shift_id && this.getShiftLogsTransaction(this.shift_id);
    },
    makeUppercase: function (str) {
      return str
        .split("")
        .map((char) => {
          return isNaN(char) ? char.toUpperCase() : char;
        })
        .join("");
    },
    getShiftLogsTransaction: function (shift_id, isExcel = "N") {
      let loader = this.$loading.show();

      ReportsService.getShiftLogsTransactions({ shift_id, isExcel })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.transactionData = data.transactionData;
            this.fnbTransactionData = data.fnbTransactionData;
            let { transactionData, fnbTransactionData } = data;
            if (transactionData.length && fnbTransactionData.length) {
              let arr = [];

              // Iterate over each element in transactionData
              transactionData.forEach((ele) => {
                // Push the current element into arr
                arr.push(ele);

                // Filter fnbTransactionData to find matching elements
                let matchingFnb = fnbTransactionData.filter(
                  (fnb) => fnb.show_booking_code === ele.show_booking_code
                );

                // If matching elements are found
                if (matchingFnb.length) {
                  let data = {
                    ...matchingFnb[0],
                    show_date_time: ele.show_date_time,
                  };
                  // Push matching elements into arr
                  arr.push(data);

                  // Remove the matching elements from fnbTransactionData
                  fnbTransactionData = fnbTransactionData.filter(
                    (fnb) => fnb.show_booking_code !== ele.show_booking_code
                  );
                }
              });
              this.combinedData = [...arr, ...fnbTransactionData];
              console.log("combinedData", this.combinedData);
            } else if (transactionData.length) {
              console.log("only transction data");
              this.combinedData = [...transactionData];
            } else if (fnbTransactionData.length) {
              console.log("only fnb data");

              this.combinedData = [...fnbTransactionData];
            }

            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
          }
          loader.hide();
        })
        .catch((error) => {
          console.log(error);
          loader.hide();
        });
    },
  },
};
</script>
<style scoped>
.left-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-bottom: 1px solid black !important;
  border-right: 0 !important;
}

.right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.borderOnly {
  border-left: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  border-right: 1px !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftCloseComponent/shiftCloseTransaction.vue